import React from 'react';
import { Quotes as QuotesComponent } from '@thd-olt-component-react/quotes';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import proptypes from 'prop-types';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

const { string } = proptypes;

export function Quotes({ id }) {

  const data = {
    name: 'Quotes',
    component: 'Quotes',
    type: 'content',
    position: '',
    id
  };

  return (
    <ErrorBoundary name="quotes">
      <QueryProvider cacheKey="quotes-cacheKey">
        <ImpressionProvider data={data}>
          {/* fillHeight: the cards stretch to match Projects beside it in the row. */}
          <QuotesComponent componentId={id} fillHeight />
        </ImpressionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

Quotes.propTypes = {
  id: string.isRequired,
};
